const basePath = "/";

const Login = () =>
  import(/* webpackChunkName: "member" */ "../src/views/login.vue");

const forgetPassword = () =>
  import(
    /* webpackChunkName: "member" */ "../src/views/forgetPassword.vue"
  );

const register = () =>
  import(/* webpackChunkName: "member" */ "../src/views/register.vue");

const termsText = () =>
  import(/* webpackChunkName: "member" */ "../src/views/termsText.vue");
  const privacyText= () =>
  import(/* webpackChunkName: "member" */ "../src/views/privacyText.vue");

// const check = () =>
//   import(/* webpackChunkName: "member" */ "../src/views/check.vue");
const serviceList = () =>
  import(/* webpackChunkName: "member" */ "../src/views/serviceList.vue");
// const qrCode = () =>
// import(/* webpackChunkName: "member" */ "../src/views/qrCode.vue");
const userInfo = () =>
  import(/* webpackChunkName: "member" */ "../src/views/userInfo.vue");
export default [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "會員登入",
    },
  },
  // {
  //   path: "/:appid/:bsKey",
  //   name: "login",
  //   component: Login,
  //   meta: {
  //     title: "login",
  //   },
  // },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: forgetPassword,
    meta: {
      title: "忘記密碼",
    },
  },
  {
    path: "/register",
    name: "register",
    component: register,
    meta: {
      title: "新會員註冊",
    },
  },
  {
    path: "*",
    name: "notFound",
    component: Login,
    meta: {
      title: "會員登入",
    },
  },
  {
    path: "/termsText",
    name: "termsText",
    component: termsText,
    meta: {
      title: "條款",
    },
  },
  {
    path: "/privacyText",
    name: "privacyText",
    component: privacyText,
    meta: {
      title: "條款",
    },
  },
  // {
  //   path: "/check",
  //   name: "check",
  //   component: check,
  //   meta: {
  //     title: "check",
  //   },
  // },
  {
    path: "/serviceList",
    name: "serviceList",
    component: serviceList,
    meta: {
      title: "服務管理",
    },
  },
  {
    path: "/userData",
    name: "userData",
    component: userInfo,
    meta: {
      title: "個人資料",
    },
  },
  
  // {
  //   path: "/qrCode",
  //   name: "qrCode",
  //   component: qrCode,
  //   meta: {
  //     title: "QRCode",
  //   },
  // },
];
